import { Icon } from '@faststore/ui'
import React from 'react'

import { ProfileDropdownClubCardPlus } from '../../../../../assets/profileDropdownIcons/ProfileDropdownClubCardPlus'
import { ProfileDropdownDiscount } from '../../../../../assets/profileDropdownIcons/ProfileDropdownDiscount'
import { ProfileDropdownLogout } from '../../../../../assets/profileDropdownIcons/ProfileDropdownLogout'
import { ProfileDropdownOrder } from '../../../../../assets/profileDropdownIcons/ProfileDropdownOrder'
import { ProfileDropdownTip } from '../../../../../assets/profileDropdownIcons/ProfileDropdownTip'
import { ProfileDropdownUser } from '../../../../../assets/profileDropdownIcons/ProfileDropdownUser'
import { useClubContext } from '../../../../../contexts/ClubContext'
import { useStoreContext } from '../../../../../contexts/StoreContext'

import './profile-dropdown.scss'

export const ProfileDropdown = () => {
  const { secureSubdomain, hasClubPlusInDropdown, account } = useStoreContext()
  const { userInfos } = useClubContext()

  const profileOptions = [
    {
      visibility: true,
      icon: <ProfileDropdownUser />,
      text: 'Minha Conta',
      link: `${secureSubdomain}/api/io/account#/`,
    },
    {
      visibility: true,
      icon: <ProfileDropdownOrder />,
      text: 'Meus Pedidos',
      link: `${secureSubdomain}/api/io/account#/orderhistory`,
    },
    {
      visibility: !!hasClubPlusInDropdown,
      icon: <ProfileDropdownClubCardPlus />,
      text: '+amigo',
      link: `${userInfos?.isCartonist ? '/cartao/cartonista' : '/clube'}`,
    },
    {
      visibility: true,
      icon: <ProfileDropdownDiscount />,
      text: 'Cupons de Desconto',
      link: '/cupons-de-oferta',
    },
    {
      visibility: true,
      icon: <ProfileDropdownLogout />,
      text: 'Sair',
      link: `${secureSubdomain}/api/vtexid/pub/logout?scope=${account}&returnUrl=/`,
    },
  ]

  return (
    <div
      className="profile-dropdown-container"
      onClick={(event) => event.stopPropagation()}
    >
      <div className="profile-dropdown-tip-container">
        <ProfileDropdownTip />
      </div>

      {profileOptions.map(({ visibility, icon, text, link }) => {
        if (visibility) {
          return (
            <a href={link} className="profile-dropdown-option" key={text}>
              <Icon component={icon} />
              <h2 className="profile-dropdown-option-text">{text}</h2>
            </a>
          )
        }

        return null
      })}
    </div>
  )
}
